import {DealerStamp} from '../DealerStamp/DealerStamp'

import type {OpeningHours} from '../DealerStamp/DealerStampDialog/OpeningHoursTable'
import type {XcNwBlock_BlockOfficeVCardType_Fragment} from '@sdox/api'

export const BlockDealerStamp = (props: XcNwBlock_BlockOfficeVCardType_Fragment) => {
  const {
    name,
    company,
    openingHoursGeneral,
    city,
    street,
    zipCode,
    streetNumber,
    email,
    phone,
    officeVCardImage,
    geoLatitude,
    geoLongitude,
  } = props

  let openingHours: OpeningHours | undefined = undefined
  if (openingHoursGeneral) {
    const {__typename, ...rest} = openingHoursGeneral
    openingHours = rest
  }

  // "name" and "company" are not required fields in the CUPRA/SEAT API
  let displayName = name
  if (name !== company && !!company) {
    displayName = [name, company].join(', ')
  }

  return (
    <DealerStamp
      name={displayName}
      openingHours={openingHours}
      address={{
        street,
        streetNumber,
        city,
        zipCode,
      }}
      coordinates={(geoLatitude && geoLongitude) ? {
        lat: geoLatitude,
        long: geoLongitude,
      } : null}
      phone={phone}
      email={email}
      image={officeVCardImage ? {
        url: officeVCardImage.thumbnailUrl,
        placeholderUrl: officeVCardImage.thumbnailUrl380w,
        alt: officeVCardImage.altText,
      } : null}
    />
  )
}
